package org.example.zone360.pages.coachDetails.coachInfo

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.DonutData
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.pages.dashboard.emphasisBreakdown.IconType
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedLanguage
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CoachInfoEmotion(
    coachData: GetSingleCoachData,
    isLoading: Boolean,
    isSaving : Boolean = false,
    breakpoint: Breakpoint
) {
    val donutData = coachData.donut
    val categories = listOf(
        "Technical" to IconType.Image(Res.Images.technical),
        "Fitness" to IconType.Image(Res.Images.fitness),
        "Tactical" to IconType.Image(Res.Images.tactical),
        "Mental" to IconType.Image(Res.Images.mental),
        "Goalkeeper" to IconType.Image(Res.Images.goalkeeper),
        "Custom" to IconType.Image(Res.Images.football_LowScale)
    )
    val categoryData = mapOf(
        "technical" to (donutData.technical ?: 0),
        "fitness" to (donutData.fitness ?: 0),
        "tactical" to (donutData.tactical ?: 0),
        "mental" to (donutData.mental ?: 0),
        "goalkeeper" to (donutData.goalkeeper ?: 0),
        "custom" to (donutData.custom ?: 0)
    )
    val totalCount = categoryData.values.sum()

    Box(
        modifier = Modifier
            .width(100.percent)
            .borderRadius(15.px)
            .padding(if (breakpoint < Breakpoint.MD) 10.px else if (isSaving) 0.px else  20.px)
    ) {
        Column(modifier = Modifier.fillMaxSize(), horizontalAlignment = Alignment.CenterHorizontally) {
            if (!isSaving) {
                SectionTitle("Emphasis Breakdown")
            }
//            when {
//                isLoading -> {
//                    Box(
//                        modifier = Modifier.fillMaxSize(),
//                        contentAlignment = Alignment.Center
//                    ) {
//                        CustomSpacer(height = 100.px)
//                        ProgressIndicator(30.px)
//                    }
//                }
//                else ->
//                    {
            if (window.screen.width > 1660 && !isSaving) {
                Row(
                    modifier = Modifier.fillMaxWidth().margin(topBottom = 10.px),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    CoachInfoDonut(coachData, isSavingPic = isSaving)
                    CustomSpacer(20.px)

                    Column(modifier = Modifier.weight(1f)) {

                        categories.forEach { (category, image) ->
                            val count = categoryData[category.lowercase()] ?: 0
                            val percentage = if (totalCount > 0) (count * 100) / totalCount else 0
                            Row(
                                modifier = Modifier.margin(bottom = 15.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    src = image.url,
                                    modifier = Modifier.size(20.px)
                                )
                                FieldTitleTextNormalSimple(
                                    "$category ($percentage%)",
                                    marginLeft = 5.px,
                                    fontSize = 13.px
                                )
                            }
                        }
                    }
                }
            } else if (isSaving) {
                Row(
                    modifier = Modifier.fillMaxWidth().margin(topBottom = 10.px),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    // Left side legend - 2 column grid
                    Column(
                        modifier = Modifier.width(55.percent)
                    ) {
                        categories.chunked(2).forEach { rowItems ->
                            Row(
                                modifier = Modifier.fillMaxWidth().margin(bottom = 13.px),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                rowItems.forEach { (category, image) ->
                                    Row(
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Image(
                                            src = image.url,
                                            modifier = Modifier.size(17.px)
                                        )
                                        FieldTitleTextNormalSimple(
                                            category,
                                            marginLeft = 5.px,
                                            fontSize = 12.px
                                        )
                                    }
                                }
                            }
                        }
                    }

                    Box(
                        modifier = Modifier.width(40.percent),
                        contentAlignment = Alignment.Center
                    ) {
                        CoachInfoDonut(coachData, isSavingPic = isSaving)
                    }
                }
            } else {
                Column(
                    modifier = Modifier.fillMaxWidth().margin(top = 10.px, bottom = 10.px),
                    horizontalAlignment = Alignment.CenterHorizontally,
                ) {
                    CoachInfoDonut(coachData, isSaving)
                    Row(
                        modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap)
                            .margin(top = 10.px),
                        horizontalArrangement = Arrangement.Center,
                    ) {
                        categories.forEach { (category, image) ->
                            val count = categoryData[category.lowercase()] ?: 0
                            val percentage = if (totalCount > 0) (count * 100) / totalCount else 0

                            Row(
                                modifier = Modifier
                                    .margin(bottom = 15.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    src = image.url,
                                    modifier = Modifier.size(20.px)
                                )

                                FieldTitleTextNormalSimple(
                                    "$category ($percentage%)",
                                    marginLeft = 5.px,
                                    fontSize = 13.px
                                )
                            }
                        }
                    }
                }

            }

//                    }

            }
        }
}

